//Holds an apex predator card
import React, { Component } from 'react';
import Card from './Card';

import './ApexCardSlot.css'
import './Card-Structure.css';
import './Card.css';

export default class ApexCardSlot extends Component {
    constructor () {
        super();

        this.createCardElement = this.createCardElement.bind (this);
        this.createFoodChainCardElement = this.createFoodChainCardElement.bind (this);
    }

    createCardElement (data, index) {
        if (!data.key || !data.position) {
            return (<div key={index}></div>)
        }

        let isFed = (this.props.givenFoodChain.length > 0)

        let extraClassNames = '';

        if (isFed) { extraClassNames = 'locked' }

        return (
            <Card
                key={this.props.name + index.toString () + Math.random ().toString ()}
                id={data.id}
                name={data.name}
                img={data.img}
                zIndex={data.zIndex}
                isActive={data.isActive}
                position={data.position}
                isFaceDown={data.isFaceDown}
                isDiscarded={data.isDiscarded}
                isPlacedInColumn={data.isPlacedInColumn}
                isProtected={data.isProtected}
                type={data.type}
                index={index}
                diet={data.diet}
                symbol={data.symbol}
                iceDestroyed={this.props.iceDestroyed}
                facts={data.facts}
                trophicLevel={data.trophicLevel}
                needsIce={data.needsIce}

                onMouseDown={this.props.onMouseDownOnCard}
                extraClassNames={extraClassNames}
            />
        )
    }

    createFoodChainCardElement (data, index) {
        let position = {
            x: -55,
            y: 10 * index + 40
        }

        data.position.y = position.y

        let zIndex = 100 + index
        let isFed = (this.props.givenFoodChain.length > 0)

        let extraClassNames = '';

        if (isFed) {
            extraClassNames = 'locked'
        }
        return (
            <Card
                key={this.props.name + index.toString () + Math.random ().toString ()}
                id={data.id}
                name={data.name}
                img={data.img}
                zIndex={zIndex}
                isActive={data.isActive}
                position={data.position}
                isFaceDown={data.isFaceDown}
                isDiscarded={data.isDiscarded}
                isPlacedInColumn={data.isPlacedInColumn}
                isProtected={data.isProtected}
                type={data.type}
                index={index}
                diet={data.diet}
                symbol={data.symbol}
                iceDestroyed={this.props.iceDestroyed}
                facts={data.facts}
                trophicLevel={data.trophicLevel}
                needsIce={data.needsIce}

                onMouseDown={() => {}}
                extraClassNames={extraClassNames}
            />
        )
    }

    render () {
        let children = this.props.children;

        if (!children) { children = [] }
        if (!children.map) { children = [children] }

        return (
            <div id={this.props.id} className="apex-card-slot">
                { children.map (this.createCardElement) }
                { this.props.givenFoodChain.map (this.createFoodChainCardElement) }
            </div>
        )
    }
}
